import { useForm } from "react-hook-form";
import { useCreateTaskMutation } from "../../../../api/tareas/tareaApi";
import { Dispatch, SetStateAction } from "react";
import { CircularProgress } from "@mui/joy";
import { InputContainer, LabelTaskForm } from "src/features/tareas/CreateTaskForm/components";
import { CreateTask } from "src/features/tareas/CreateTaskForm/types";

interface Props {
    empresaId: number;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export function CreateTaskForm({ empresaId, setIsOpen }: Props) {
    const [createTask, { isLoading }] = useCreateTaskMutation();

    const {
        register,
        handleSubmit,
        formState: { errors, },
    } = useForm<CreateTask>({ defaultValues: { enableSendNotification: false }})

    const onSubmitTask = handleSubmit(async (data: CreateTask) => {
        try {
            data.horaInicio = `${data.horaInicio}:00`;
            data.horaFin = data.horaFin && data.horaFin?.length > 0 ? `${data.horaFin}:00` : null;
            data.fechaFin = data.fechaFin && data.fechaFin.length > 0 ? data.fechaFin : null;

            data.empresaId = empresaId

            await createTask(data).unwrap()

            setIsOpen(false);
            
        } catch (error) {
            console.error(error);
        }
    });

    return (
        <div className="p-4">
            <p className="text-gray-600 font-medium pb-2 text-xl">
                Crear nueva tarea
            </p>

            <form onSubmit={onSubmitTask}>
                <div className="flex flex-col">
                    <LabelTaskForm>Titulo</LabelTaskForm>
                    <input 
                        {...register("titulo", {
                            required: "La tarea necesita un titulo.",
                            maxLength: 40,
                        })}
                        className="
                            border-gray-400 focus:outline-none focus:border-gray-800 pl-2
                            focus:border-2 border rounded text-gray-600 font-normal hover:border-2"
                        autoComplete="off"
                        type="text" />
                </div>

                {errors.titulo?.type === "required" && (
                    <p className="valErrorText">{errors.titulo.message}</p>
                )}
                {errors.titulo?.type === "maxLength" && (
                    <p className="valErrorText">La cantidad maxima de caracteres es 40</p>
                )}

                <div className="flex flex-col">
                    <LabelTaskForm>Descripción</LabelTaskForm>
                    <textarea
                        {...register("texto")}
                        className="
                            border-gray-400 focus:outline-none focus:border-gray-800 pl-2 h-[80px] resize-none
                            focus:border-2 border rounded text-gray-600 font-normal hover:border-2"
                        autoComplete="off"></textarea>
                </div>

                <div className="flex gap-x-10">
                    <div className="flex flex-col">
                        <InputContainer>
                            <LabelTaskForm>Fecha de inicio</LabelTaskForm>
                            <input 
                                {...register("fechaInicio", {
                                    required: "La tarea requiere una fecha inicial."
                                })}
                                className="
                                    border-gray-400 focus:outline-none focus:border-gray-800 pl-2
                                    focus:border-2 border rounded text-gray-600 font-normal hover:border-2"
                                type="date" />
                        </InputContainer>

                        {errors.fechaInicio?.type === "required" && (
                            <p className="valErrorText">{errors.fechaInicio.message}</p>
                        )}

                        <InputContainer>
                            <LabelTaskForm>hora de inicio</LabelTaskForm>
                            <input
                                {...register("horaInicio", {
                                    required: "La tarea requiere una hora inicial."
                                })}
                                className="
                                    border-gray-400 focus:outline-none focus:border-gray-800 pl-2 flex-1s
                                    focus:border-2 border rounded text-gray-600 font-normal hover:border-2"
                                type="time" />
                        </InputContainer>

                        {errors.horaInicio?.type === "required" && (
                            <p className="valErrorText">{errors.horaInicio.message}</p>
                        )}
                    </div>

                    <div className="flex flex-col">
                        <InputContainer>
                            <LabelTaskForm>Fecha de fin</LabelTaskForm>
                            <input 
                                {...register("fechaFin")}
                                className="
                                    border-gray-400 focus:outline-none focus:border-gray-800 pl-2
                                    focus:border-2 border rounded text-gray-600 font-normal hover:border-2"
                                type="date" />
                        </InputContainer>


                        <InputContainer>
                            <LabelTaskForm>hora de fin</LabelTaskForm>
                            <input
                                {...register("horaFin")}
                                className="
                                    border-gray-400 focus:outline-none focus:border-gray-800 pl-2
                                    focus:border-2 border rounded text-gray-600 font-normal hover:border-2"
                                type="time" />
                        </InputContainer>
                    </div>
                </div>


                <div>
                    <div className="flex items-center gap-x-3">
                        <LabelTaskForm>Enviar recordatorio (1 día antes)</LabelTaskForm>
                        <input
                            {...register("enableSendNotification")}
                            type="checkbox"
                            className="
                                border-gray-400 focus:outline-none focus:border-gray-800 pl-2 w-[15px] h-[15px]
                                focus:border-2 border rounded text-gray-600 font-normal hover:border-2"/>
                    </div>
                </div>

                <div className="flex justify-center gap-x-2">
                    {isLoading
                    ? 
                    <CircularProgress sx={{
                        "--CircularProgress-progressThickness": "4px",
                        "--CircularProgress-trackThickness": "4px",
                        "--CircularProgress-size": "24px"
                    }}/>
                    :
                    <>
                    <input 
                        className="bg-green-800 rounded font-semibold px-2 text-white py-[2px] text-sm w-[84px]"
                        type="submit"
                        value="crear tarea" />

                    <button 
                        type="button"
                        onClick={() => setIsOpen(false)}
                        className="bg-gray-500 rounded font-semibold px-2 text-white py-[2px] text-sm w-[84px]">
                        Cerrar
                    </button>
                    </>
                    }
                </div>

            </form>
        </div>
    );
}